import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { ImageSourceSetData } from "../../../../common/classes/ImageSourceSet";
import FormInput from "../../../../common/forms/FormInput";
import { getDefaultImage } from "../../../../utils/GeneralUtils";
import { ValType } from "../../../../utils/ValidationFunctions";
import styles from "../MyPageEditModal.module.scss";
import { SonicWorkInputData } from "./SonicWorkInputData";

type Props = {
  index: number;
  image?: File | ImageSourceSetData;
  title?: string;
  link?: string;
  description?: string;
  editWork: (i: number, work: SonicWorkInputData) => void;
  closeHandler: () => void;
  isPreview?: boolean;
};
const EditWorkModal: React.FC<Props> = ({
  index,
  image,
  title,
  link,
  description,
  editWork,
  closeHandler,
  isPreview = false,
}) => {
  useEffect(() => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = "hidden";
    }

    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);

  const [error, setError] = useState<boolean>(false);
  const [workItem, setWorkItem] = useState<SonicWorkInputData>({
    title: title ? title : "",
    description: description ? description : "",
    link: link ? link : "",
    image: image ? image : undefined,
    error: false,
  });

  const handleInputChange = (
    value: string | File | undefined,
    name: string
  ) => {
    const work = workItem;

    switch (name) {
      case "title":
        setError(false);
        if (typeof value !== "string" && value !== undefined) break;
        work.title = value ? value : "";
        break;
      case "description":
        if (typeof value !== "string") break;
        work.description = value;
        break;
      case "link":
        if (typeof value !== "string") break;
        work.link = value;
        break;
      case "image":
        if (!(value instanceof File)) break;
        work.image = value;
        break;
      default:
        break;
    }

    if (value !== undefined) {
      work.error = false;
    } else {
      work.error = true;
    }

    setWorkItem({ ...workItem });
  };
  return (
    <div className={styles["mypage-editModal-wrapper"]}>
      <div className={styles["mypage-editModal"]}>
        <div className={styles["mypage-editModal__title"]}>作品登録</div>
        <i className={styles["mypage-editModal__close"]} onClick={closeHandler}>
          <FontAwesomeIcon icon={["fas", "times"]} />
        </i>
        <div className={styles["mypage-editModal__form"]}>
          <div className={styles["mypage-editModal__form-title"]}>画像</div>
          <div className={styles["imgBox"]}>
            <img
              src={
                !workItem.image
                  ? getDefaultImage()
                  : workItem.image instanceof File
                  ? URL.createObjectURL(workItem.image)
                  : workItem.image.thumbnail?.url
              }
            />
          </div>
          {!isPreview ? (
            <FormInput
              type="file"
              label="画像を選択"
              label_class={styles["mypage-editModal__form-file-btn"]}
              id="work_image"
              name="image"
              style_class={styles["mypage-editModal__form-file-input"]}
              handler={handleInputChange}
              val_type={ValType.File}
            />
          ) : null}
        </div>
        <div className={styles["mypage-editModal__form"]}>
          {!isPreview ? (
            <FormInput
              type="text"
              label="作品タイトル"
              label_class={`${styles["mypage-editModal__form-title"]} ${styles["required-mark"]}`}
              name="title"
              placeholder="作品タイトルを入力"
              style_class={styles["mypage-editModal__form-input"]}
              handler={handleInputChange}
              initial_value={workItem.title}
              val_type={ValType.NotNull}
              merit_text="タイトルがあるとわかりやすいです"
            />
          ) : (
            <>
              <span className={styles["mypage-editModal__form-title"]}>
                作品タイトル
              </span>
              <div className={styles["mypage-editModal__form-preview"]}>
                {workItem.title}
              </div>
            </>
          )}
        </div>
        <div className={styles["mypage-editModal__form"]}>
          {!isPreview ? (
            <FormInput
              type="text"
              label="作品URL"
              label_class={styles["mypage-editModal__form-title"]}
              name="link"
              placeholder="URLを入力"
              style_class={styles["mypage-editModal__form-input"]}
              handler={handleInputChange}
              initial_value={workItem.link}
              merit_text="リンクがあると実際に閲覧できるのでわかりやすいです"
            />
          ) : (
            <>
              <span className={styles["mypage-editModal__form-title"]}>
                作品URL
              </span>
              <div className={styles["mypage-editModal__form-preview"]}>
                {workItem.link}
              </div>
            </>
          )}
        </div>
        <div className={styles["mypage-editModal__form"]}>
          {!isPreview ? (
            <FormInput
              type="textarea"
              label="作品説明"
              label_class={styles["mypage-editModal__form-title"]}
              name="description"
              placeholder={`作品の説明を入力\n制作期間や担当箇所、使用ツール等\n記入例：\n制作期間▶20xx年xx月～20△△年△△月\n担当箇所▶デザイン・チームマネージメント\n使用ツール▶Photoshop/Illustrator`}
              style_class={`${styles["mypage-editModal__form-input"]} ${styles["textarea"]}`}
              rows={8}
              handler={handleInputChange}
              initial_value={workItem.description}
              merit_text="説明があるとあなたのスキルやできることがわかりやすいです"
            />
          ) : (
            <>
              <span className={styles["mypage-editModal__form-title"]}>
                作品説明
              </span>
              <div className={styles["mypage-editModal__form-preview"]}>
                {workItem.description}
              </div>
            </>
          )}
        </div>
        {error ? (
          <div className={styles["mypage-editModal__error"]}>
            必須項目が入力されていません
          </div>
        ) : null}
        <div className={styles["mypage-editModal__btn-area"]}>
          {!isPreview ? (
            <>
              <button
                className={`${styles["mypage-editModal__btn-area__btn"]} ${styles["cancel"]}`}
                type="button"
                onClick={closeHandler}
              >
                キャンセル
              </button>
              <button
                className={`${styles["mypage-editModal__btn-area__btn"]} ${styles["confirm"]}`}
                type="button"
                onClick={() => {
                  if (!workItem.title) {
                    setError(true);
                  } else {
                    editWork(index, workItem);
                    setError(false);
                    closeHandler();
                  }
                }}
              >
                OK
              </button>
            </>
          ) : (
            <button
              className={`${styles["mypage-editModal__btn-area__btn"]} ${styles["close"]}`}
              type="button"
              onClick={closeHandler}
            >
              閉じる
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditWorkModal;
